import { compose, values, join, filter, not, isEmpty, replace } from 'ramda';

import { DEFAULT_APP_NAME } from 'app/router/constants/paths';
import { routerLocales } from 'app/router/constants/routerLocales';

const joinedLocales = compose(
  replace(/\//g, ''),
  join('|'),
  filter(compose(not, isEmpty)),
  values,
)(routerLocales);

const pathRegex = `/:locale(${joinedLocales})?/:app(campaign-\\w+|offer-\\w+|${DEFAULT_APP_NAME})`;
const buildPathRegex = path => `${pathRegex}${path}`;

export { buildPathRegex, pathRegex };
